import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Keyboard } from '@material-ui/icons';
import cx from 'classnames';
import { AnimatePresence } from 'framer-motion';
import Modal from '../../Modal/Modal';
import { EventEmitter } from '../../../utils';

class Hotkeys extends Component {
  static propTypes = {
    editor: PropTypes.object,
    value: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };

    this.toggleModal = this.toggleModal.bind(this);
  }

  componentDidMount() {
    EventEmitter.listen('open-modal--hotkey', () => {
      this.toggleModal();
    });
  }

  toggleModal() {
    this.setState(prevState => ({ showModal: !prevState.showModal }));
  }

  tableRow(command, func, lastRow = false) {
    return (
      <tr>
        <td className="w-1/2 text-right px-4">
          <span
            className={cx('shadow-md px-2 rounded font-bold', {
              'mb-4': !lastRow,
            })}>
            {command}
          </span>
        </td>
        <td className="w-1/2 px-4">
          <span
            className={cx('shadow-md px-2 rounded font-bold', {
              'mb-4': !lastRow,
            })}>
            {func}
          </span>
        </td>
      </tr>
    );
  }

  render() {
    return (
      <span className="icon__wrapper icon__wrapper--hotkeys">
        <button
          title="Hotkeys"
          className={cx('icon__button', {
            active: this.state.showModal,
          })}
          onClick={this.toggleModal}>
          <Keyboard />
        </button>
        <AnimatePresence>
          {this.state.showModal && (
            <Modal
              onDismiss={this.toggleModal}
              title={<h3 className="m-0">Hotkeys</h3>}
              name="hotkey-modal">
              <table className="w-full">
                <tbody>
                  {this.tableRow('ctrl + b', 'Bold')}
                  {this.tableRow('ctrl + i', 'Italic')}
                  {this.tableRow('ctrl + u', 'Underline')}
                  {this.tableRow('ctrl + ,', 'Open hotkeys modal')}
                  {this.tableRow('ctrl + shift + i', 'Open image popup')}
                  {this.tableRow('ctrl + shift + l', 'Open link popup')}
                  {this.tableRow('ctrl + shift + s', 'Open snippet popup')}
                  {this.tableRow('ctrl + shift + t', 'Open table popup')}
                  {this.tableRow('ctrl + shift + f', 'Toggle fullscreen', true)}
                </tbody>
              </table>
            </Modal>
          )}
        </AnimatePresence>
      </span>
    );
  }
}

export default  Hotkeys;
